<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div>
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Nome</label>
                    <div class="field-label">{{ objView.nmpessoa }}</div>
                </div>
            </div>


            <div v-if="!modoEdicao">
                <div class="row row-space">
                    <div class="form-item-data">
                        <label class="label-caption">Data</label>
                        <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtsolicitacao) }}</div>
                    </div>

                    <div class="form-item-data">
                        <label class="label-caption">Prazo</label>
                        <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dtprazo) }}</div>
                    </div>

                    <div class="form-item">
                        <label class="label-caption">Solicitação</label>
                        <div class="field-label">{{ objView.solicitacao }}</div>
                    </div>

                    <div class="form-item-char20">
                        <label class="label-caption">Situação</label>
                        <div class="field-label">{{ objView.nmstatus }}</div>
                    </div>
                </div>

                
                <div class="row row-space">
                    <div class="form-item-char40">
                        <label class="label-caption">Departamento</label>
                        <div class="field-label">{{ objView.nmdepartamento }}</div>
                    </div>
                    
                    <div class="form-item-char30">
                        <label class="label-caption">Data atendimento</label>
                        <div class="field-label">{{ Funcoes.formatDateTimeFromJson(objView.dhatendimento) }}</div>
                    </div>

                    <div class="form-item">
                        <label class="label-caption">Observações</label>
                        <div class="field-label">{{ objView.obatendimento }}</div>
                    </div>
                </div>


                <div class="row-start">
                    <button class="btn-small" @click="setEdicao()">EDITAR</button>
                    <button class="btn-small" @click="closeForm">RETORNAR</button>
                </div>
            </div>
            <div v-else>
                <div class="row row-space">
                    <div class="form-item-data">
                        <label class="label-caption">Data</label>
                        <input type="date" v-model="edDataSolicitacao" />
                    </div>

                    <div class="form-item-data">
                        <label class="label-caption">Prazo</label>
                        <input type="date" v-model="edDataPrazo" />
                    </div>

                    <div class="form-item">
                        <label class="label-caption">Solicitação</label>
                        <input type="text" v-model="edSolicitacao" maxlength="100" v-uppercase />
                    </div>

                    <div class="form-item-char40"><GabineteDepartamentoSelect v-model:departamentoSelecionado="idDepartamento"/></div>
                </div>


                <div class="row row-space">
                    <div class="form-item">
                        <textarea v-model="edObsEdicao" maxlength="3000" rows="5" style="resize: none;"/>
                    </div>
                </div>


                <div class="row-start">
                    <button class="btn-small" @click="salvarSolicitacao">SALVAR</button>
                    <button class="btn-small" @click="modoEdicao=false">CANCELAR</button>
                </div>
                
            </div>
        </div>
    </div>


    <div v-if="!modoEdicao">
        <div
            v-for="item in lsHistorico"
            :key="item.id"
            class="historico-card row-space"
        >
            <div class="historico-header">
                <div class="form-item-char15">
                    <label class="label-caption">Data</label>
                    <div class="field-label field-label-center">
                        {{ Funcoes.formatDateFromJson(item.dthistorico) }}
                    </div>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Hora</label>
                    <div class="field-label field-label-center">
                        {{ Funcoes.formatTimeFromJson(item.hrhistorico) }}
                    </div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Usuário</label>
                    <div class="field-label">
                        {{ item.nmusuario }}
                    </div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Tipo</label>
                    <div class="field-label">
                        {{ item.nmtipohistorico }}
                    </div>
                </div>
            </div>

            <div class="historico-obs">
                {{ item.obs }}
            </div>
        </div>


        <div class="form-edit-page">
            <div v-if="msgAlertaDados" class="info-alert row-space clickabe" @click="msgAlertaDados=null"><span class="text">{{ msgAlertaDados }}</span></div>

            <div class="row-start row-space">
                <div class="form-item-data">
                    <label class="label-caption">Data</label>
                    <input type="date" v-model="edDtHistorico" />
                </div>

                <div class="form-item-char05">
                    <label class="label-caption">Hora</label>
                    <input type="text" class="input-center" v-time-mask v-model="edHrHistorico" />
                </div>

                <button class="btn-small" @click="salvarHistorico">INCLUIR</button>
            </div>

            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Observações</label>
                    <textarea v-model="edObs" maxlength="1000" rows="5" style="resize: none;"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import { Funcoes } from '@/funcoes/utils';
import { Validar } from '@/funcoes/validacoes';
import GabineteDepartamentoSelect from '@/selects/GabineteDepartamentoSelect.vue';

const emit = defineEmits(['close','save']);
const props = defineProps({idView: {type: Number, default: 0}});

const emitSave= ref(false);
const isLoading = ref(false);
const modoEdicao = ref(false);
const msgAlerta = ref(null);
const msgAlertaDados = ref(null);
const objView = ref({});

const edDataPrazo = ref(null);
const edDataSolicitacao = ref(null);
const edSolicitacao = ref(null);
const edObsEdicao = ref(null);
const idDepartamento = ref(null);

const edDtHistorico = ref(Funcoes.dataAtual());
const edHrHistorico = ref(Funcoes.strHoraAtual());
const edObs = ref(null);
const lsHistorico = ref([]);


const closeForm = () => {
    if (emitSave.value){emit('save')}
    emit('close'); 
}


const lerDados = async() => {
    try{
        isLoading.value = true;
        msgAlerta.value=null;
        const req = await Api.genericPost('/listas/gabinete/solicitacoes', {idmunicipio: globalStore.idmunicipio, id: props.idView});
        Object.assign(objView.value, req[0]);
        await lerHistorico();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


async function lerHistorico(){
    try{
        isLoading.value = true;
        msgAlerta.value=null;
        const req = await Api.genericPost('/listas/gabinete/solicitacoes/historico', {
            idmunicipio: globalStore.idmunicipio,
            intparam1: props.idView});
        lsHistorico.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    }finally{isLoading.value = false;}
}


async function salvarHistorico(){
    try {
        msgAlertaDados.value = validarDadosHistorico();
        if (msgAlertaDados.value) return;

        isLoading.value=true;
        const r = await Api.genericPut('/cad/gabinete_solicitacao_historico', {
            idgabinetesolicitacao: props.idView,
            dthistorico: edDtHistorico.value,
            hrhistorico: edHrHistorico.value,
            obs: edObs.value,
            cdtipohistorico: 1,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (r.bolok===1){
            await lerHistorico();
            edObs.value = null;
        } else {msgAlertaDados.value=r.erro}
    } catch (error){msgAlertaDados.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value=false;}
}


async function salvarSolicitacao(){
    try {
        msgAlerta.value = validarDadosSolicitacao();
        if (msgAlerta.value) return;

        isLoading.value=true;
        const r = await Api.genericPut('/cad/gabinete_solicitacao', {
            id: props.idView,
            iddepartamento: idDepartamento.value,
            dtsolicitacao: edDataSolicitacao.value,
            dtprazo: edDataPrazo.value,
            solicitacao: edSolicitacao.value,
            obs: edObsEdicao.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (r.bolok===1){
            await lerDados();
            modoEdicao.value=false;
        } else {msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value=false;}
}


function setEdicao(){
    edDataSolicitacao.value = objView.value.dtsolicitacao;
    edDataPrazo.value = objView.value.dtprazo;
    edSolicitacao.value = objView.value.solicitacao;
    idDepartamento.value = objView.value.iddepartamento;
    edObsEdicao.value = objView.value.obs;
    modoEdicao.value = true;
}


function validarDadosHistorico(){
    let r = Validar.data(edDtHistorico.value, -1000, 'HISTÓRICO');
    if (!r.ok) return r.msg;
    r = Validar.hora(edHrHistorico.value, 'HISTÓRICO');
    if (!r.ok) return r.msg;
    r = Validar.texto(edObs.value, 'Informe dados de observações');
    if (!r.ok) return r.msg;
    return null;    
}


function validarDadosSolicitacao(){
    let r = Validar.data(edDataSolicitacao.value, -1000, 'SOLICITAÇÃO');
    if (!r.ok) return r.msg;
    r = Validar.data(edDataPrazo.value, -1000, 'SOLICITAÇÃO');
    if (!r.ok) return r.msg;
    r = Validar.texto(edSolicitacao.value, 'SOLICITAÇÃO');
    if (!r.ok) return r.msg;
    r = Validar.numeroPositivo(idDepartamento.value, 'Informe o departamento');
    if (!r.ok) return r.msg;
    return null;    
}

onMounted(lerDados);
</script>

<style scoped>
.historico-card {
    border: 2px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    background: #fff;
}

.historico-header {
    display: flex;
    gap: 10px;
    align-items: flex-end;
    margin-bottom: 8px;
}

.historico-obs {
    width: 100%;
    min-height: 38px;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
    background: #f9f9f9;
    text-align: left;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.35;
    font-size: 0.95rem;
}
</style>